export default "__VITE_ASSET__CSshzquC__"